import { Stack, Tooltip, Typography, type TooltipProps } from '@mui/material';
import classnames from 'classnames';
import React from 'react';

interface TooltipContentProps {
  isAuthorized?: boolean;
  isFeatureSupported?: boolean;
  title: string | null;
  overrideTitle?: boolean;
}

const TooltipContent = (props: TooltipContentProps) => {
  const shouldShowTitle =
    props.title &&
    (!props.overrideTitle || (props.isAuthorized && props.isFeatureSupported));

  return (
    <Stack marginX='4px' direction='column' gap='4px'>
      {shouldShowTitle && (
        <Typography
          className={classnames('text-xs', {
            'font-semibold': !props.isAuthorized,
          })}
          color='var(--mui-palette-primary-dark)'
        >
          {props.title}
        </Typography>
      )}
      {!props.isAuthorized && (
        <Typography
          width='176px'
          color='var(--mui-palette-primary-dark)'
          className='text-xs'
        >
          An admin has blocked this action for your current user role.
        </Typography>
      )}
      {props.isAuthorized && !props.isFeatureSupported && (
        <Typography
          width='176px'
          color='var(--mui-palette-primary-dark)'
          className='text-xs'
        >
          {`In order to use this feature, update the relevant account's permissions version.`}
        </Typography>
      )}
    </Stack>
  );
};

interface AuthorizationTooltipProps extends Omit<TooltipProps, 'title'> {
  isAuthorized?: boolean;
  isFeatureSupported?: boolean;
  title?: string;
  overrideTitle?: boolean;
}

export const AuthorizationTooltip = (props: AuthorizationTooltipProps) => {
  const {
    children,
    isAuthorized = true,
    isFeatureSupported = true,
    overrideTitle = false,
    ...tooltipProps
  } = props;
  const tooltipTitle =
    props.title || !isAuthorized || !isFeatureSupported ? (
      <TooltipContent
        isAuthorized={isAuthorized}
        isFeatureSupported={isFeatureSupported}
        title={props.title || null}
        overrideTitle={overrideTitle}
      />
    ) : undefined;

  return (
    <Tooltip {...tooltipProps} title={tooltipTitle}>
      <span>{children}</span>
    </Tooltip>
  );
};
